import config from '@/common/config.js';
import func from '@/common/function.js';
import jump from '@/common/libs/jump/jump.js';

const sk = {
	config,
	func,
	jump
}

uni.$sk = sk;

export default sk;